











import { Component, Prop, Vue } from 'vue-property-decorator'
import LoginForm from '@/components/LoginForm.vue'

@Component({
	components: {
		LoginForm,
	},
})
export default class Login extends Vue {
	private login(login) {
		this.$store.dispatch('login', login).then(() => {
			this.$router.replace(this.$route.query.redirect || '/')
		}, (error) => {
			alert('Incorrect login')
		})
	}
}
